<div class="reveal-overlay">
  <div class="reveal sign-in sign-in--password sign-in--forgotten-password">
    <mono-common-modal-header
      signInHeader="true"
      [headerText]="forgottenPasswordCms?.data?.attributes?.header"
    ></mono-common-modal-header>
    <main id="content" #content>
      <ul class="no-bullet sign-in__icons-list margin-bottom-0">
        <li class="icon-on-left">
          <svg
            class="icon icon--checkmark icon--success"
            width="21"
            height="21"
          >
            <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
          </svg>
          <span *ngIf="signInEmail"
            >{{ forgottenPasswordCms?.data?.attributes?.newPassword?.numberSentToEmailMessage }}</span
          >
          <span *ngIf="!signInEmail"
            >{{ forgottenPasswordCms?.data?.attributes?.newPassword?.numberSentToMobileMessage }}</span
          >
        </li>
        <li>
          <a [routerLink]="signInPasswordStage"
            class="button button--icon-on-left underline clear"
          >
            <svg class="icon icon--arrow-left" width="20" height="20">
              <use xlink:href="#icon-arrow-left" href="#icon-arrow-left"></use>
            </svg>
            <span
              >{{ forgottenPasswordCms?.data?.attributes?.newPassword?.rememberedPassword }}</span
            >
          </a>
        </li>
      </ul>
      <hr />
      <div class="position-relative">
        <section
          attr.role="alert"
          tabindex="-1"
          class="enter-code-popout enter-code-popout--code"
          #enterResetCodeSlider
          [ngStyle]="
            showEnterResetCodeSlider
              ? { 'top.px': 0, opacity: 1 }
              : { 'top.px': slideTopPosition, opacity: 1 }
          "
          [ngClass]="openHelpPopup === 'resetCode'  ? 'reset-code-help-open' : ''"
        >
          <form
            [formGroup]="resetCodeForm"
            #resetCodeSliderForm
            class="form--code"
          >
            <mono-common-help-popup
              [title]="forgottenPasswordCms?.data?.attributes?.incorrectCodeErrorHelp.title"
              [message]="forgottenPasswordCms?.data?.attributes?.incorrectCodeErrorHelp.description"
              helpPopupPosition="top"
              [open]="openHelpPopup === 'resetCode'"
              [shadow]="false"
              (removeHelpMessage)="closeTheHelpPopup()"
              [pointer]="true"
              [elementAttachedTo]="_resetCodeInputWrapper"
            ></mono-common-help-popup>
            <legend class="show-for-sr">{{ forgottenPasswordCms?.data?.attributes?.verificationSlider.screenReaderLegend }}</legend>
            <label
              *ngIf="signInEmail"
              id="resetCodeAriaId"
              for="resetCode"
              >{{ forgottenPasswordCms?.data?.attributes?.verificationSlider.emailLabel }}</label
            >
            <label
              *ngIf="!signInEmail"
              id="resetCodeAriaId"
              for="resetCode"
              >{{ forgottenPasswordCms?.data?.attributes?.verificationSlider.mobileLabel }}</label
            >
            <div
              class="input-group--code"
              #resetCodeInputWrapper
            >
              <mono-common-input-with-done-button
                [disableDoneButton]="resetCodeForm.controls.resetCode.errors || canNavigate"
                (doneButtonClick)="doneButtonClicked('resetCode')"
                [language]="authProcessProvider.language"
              >
                <ng-container input>
                  <input
                    class="input-group-field"
                    type="text"
                    id="resetCode"
                    #resetCodeInput
                    formControlName="resetCode"
                    autocomplete="off"
                    name="resetCode"
                    aria-labelledby="resetCodeAriaId"
                    maxlength="6"
                    pattern="[0-9]*"
                    inputmode="numeric"
                  />
                </ng-container>
              </mono-common-input-with-done-button>
            </div>
          </form>
          <hr />
          <button
            type="button"
            class="button clear button--icon-on-right padding-0"
            (click)="sendNewCode()"
            [disabled]="showFeedbackCallout === 'resetCode' || showSendingLoader"
            [ngClass]="!showSendingLoader ? 'underline' : ''"
          >
            <ng-container *ngIf="!showSendingLoader">
              <span>{{ forgottenPasswordCms?.data?.attributes?.verificationSlider.sendNewNumber }}</span>
              <svg
                *ngIf="signInEmail"
                class="icon icon--send-code icon--dark icon--material"
                viewBox="0 0 24 24"
              >
                <use
                  xlink:href="#icon-send-code-email"
                  href="#icon-send-code-email"
                ></use>
              </svg>
              <svg
                *ngIf="!signInEmail"
                class="icon icon--send-code icon--send-code-mobile icon--dark icon--material"
                viewBox="0 0 24 24"
              >
                <use
                  xlink:href="#icon-send-code-mobile"
                  href="#icon-send-code-mobile"
                ></use>
              </svg>
            </ng-container>
            <ng-container *ngIf="showSendingLoader">
              <span>{{ forgottenPasswordCms?.data?.attributes?.verificationSlider.sendingNewNumberLoader }}</span>
              <mono-common-loading-animation></mono-common-loading-animation>
            </ng-container>
          </button>
        </section>
      </div>
      <form
        [formGroup]="newPasswordForm"
        #passwordForm
        [ngStyle]="openHelpPopup === 'password' ? { 'z-index': 106 } : ''"
        class="form--new-password"
      >
        <mono-common-password-help-popup
          [passwordHelp]="forgottenPasswordCms?.data?.attributes?.newPassword?.help"
          [inputAttachedTo]="_passwordInputWrapper"
          (helpPopupToggleEmit)="openTheHelpPopup($event ? 'password' : '')"
        >
        </mono-common-password-help-popup>
        <fieldset [disabled]="showEnterResetCodeSlider">
          <legend class="show-for-sr">{{ forgottenPasswordCms?.data?.attributes?.newPassword?.input?.screenReaderLegend }}</legend>
          <label for="new-password">{{ forgottenPasswordCms?.data?.attributes?.newPassword?.input?.label }}</label>
          <div
            #passwordInputWrapper
            class="input-group--password input-group--with-info-text"
          >
            <mono-common-input-with-done-button
              (doneButtonClick)="doneButtonClicked('password')"
              [disableDoneButton]="newPasswordForm.controls.newPassword.errors || canNavigate"
              [language]="authProcessProvider.language"
            >
              <ng-container input>
                <input
                  class="input-group-field"
                  [type]="showPassword ? 'text' : 'password'"
                  id="new-password"
                  #passwordInput
                  formControlName="newPassword"
                  autocomplete="new-password"
                  name="new-password"
                  maxlength="50"
                  aria-labelledby="passwordAriaId"
                  (focus)="onPasswordInputFocus()"
                  (blur)="inputBlurred()"
                  aria-required="true"
                />
                <mono-common-show-hide-password-toggle
                  [language]="authProcessProvider.language"
                  (showToggle)="showPasswordToggle()"
                ></mono-common-show-hide-password-toggle>
              </ng-container>
            </mono-common-input-with-done-button>
          </div>
          <mono-common-callout
            data-test="lmw-auth-sign-in-new-password-callout--info"
            base="info"
            type="info-text"
            animation="no-animation"
            [calloutText]="forgottenPasswordCms?.data?.attributes?.newPassword?.input?.information"
          >
          </mono-common-callout>
        </fieldset>
        <div
          class="form-disabled-overlay"
          [ngClass]="showEnterResetCodeSlider || showFeedbackCallout === 'tooManyCodeRequests' || showFeedbackCallout === 'tooManySignInAttempts' ? 'fade-up' : 'hide'"
          aria-hidden="true"
        ></div>
      </form>
    </main>
    <div role="alert" [attr.aria-hidden]="showFeedbackCallout === 'resetCode' || showFeedbackCallout === 'password' ? 'false' : 'true'"
      class="feedback-callout feedback-callout--message flex-container align-center"
      [ngClass]="
      showFeedbackCallout === 'resetCode' || showFeedbackCallout === 'password' ? 'fade-up' : ''
      "
    >
      <mono-common-callout
        data-test="lmw-auth-success-callout--info"
        base="info"
        type="info-box"
        [success]="showFeedbackCallout === 'resetCode' || showFeedbackCallout === 'password'"
        [calloutText]="showFeedbackCallout === 'resetCode' ? forgottenPasswordCms?.data?.attributes?.newNumberSentSuccess : forgottenPasswordCms?.data?.attributes?.newPasswordSetSuccess"
      ></mono-common-callout>
    </div>
    <div role="alert" [attr.aria-hidden]="showFeedbackCallout === 'tooManyCodeRequests' ? 'false' : 'true'"
      class="feedback-callout feedback-callout--message-slider feedback-callout--message-slider--password flex-container align-center"
      [ngStyle]="showFeedbackCallout === 'tooManyCodeRequests' ? { transform: 'translate(-50%, 0)' } : {  transform: 'translate(-50%, 105%)' }"
    >
      <mono-common-callout
        data-test="lmw-auth-success-callout--info"
        base="info"
        type="info-box"
        [error]="true"
        [calloutText]="forgottenPasswordCms?.data?.attributes?.tooManyCodeRequestsError?.text"
        [errorDescription]="forgottenPasswordCms?.data?.attributes?.tooManyCodeRequestsError?.errorDescription"
      ></mono-common-callout>
    </div>
    <div role="alert" [attr.aria-hidden]="showFeedbackCallout === 'tooManySignInAttempts' ? 'false' : 'true'"
      class="feedback-callout feedback-callout--message-slider feedback-callout--message-slider--password flex-container align-center"
      [ngStyle]="showFeedbackCallout === 'tooManySignInAttempts' ? { transform: 'translate(-50%, 0)' } : {  transform: 'translate(-50%, 105%)' }"
    >
      <mono-common-callout
        data-test="lmw-auth-success-callout--info"
        base="info"
        type="info-box"
        error="true"
        [calloutText]="forgottenPasswordCms?.data?.attributes?.inputCodeIncorrectlyTooManyTimesError?.text"
        [errorDescription]="forgottenPasswordCms?.data?.attributes?.inputCodeIncorrectlyTooManyTimesError?.errorDescription"

      ></mono-common-callout>
    </div>
    <footer class="footer--sign-in" #footer>
      <div class="button-container">
        <button
          [disabled]="!canNavigate"
          (click)="newPasswordButtonClicked()"
          type="button"
          class="button primary expanded large"
        >
          <span *ngIf="!(showSignInLoader | async)"
            >{{ forgottenPasswordCms?.data?.attributes?.newPassword?.submitNewPasswordButton }}</span
          >
          <ng-container *ngIf="showSignInLoader | async">
            <span
              >{{ forgottenPasswordCms?.data?.attributes?.newPassword?.signingUserInLoader }}</span
            >
            <mono-common-loading-animation></mono-common-loading-animation>
          </ng-container>
        </button>
      </div>
    </footer>
  </div>
</div>
